function debounce(func){
    var timer;
    return function(event){
      if(timer) clearTimeout(timer);
      timer = setTimeout(func,100,event);
    };
}

async function domReady(fn){
    // If we're early to the party
    document.addEventListener("DOMContentLoaded", fn);
    // If late; I mean on time.
    if (document.readyState === "interactive" || document.readyState === "complete" ) {
        return document.readyState
    }
}

domReady().then(()=>{
    initLayout().then(()=>{
        initScrollMagic()
        setStickyPos()
    })

    window.addEventListener('resize',debounce(()=>{
        initLayout().then(()=>{
            updateScrollMagic()
            setStickyPos()
        })
    }))
});

function setStickyPos(){
    //sticky position to center of vertical height
    var stickyEl = document.querySelector('#be-clever-anim-img-cont'),
        header = document.querySelector('header'),
        bulletNav = document.querySelector('#be-anim-bulletnav')

    if(window.innerWidth > 1024){
        stickyEl.style.top = (window.innerHeight- stickyEl.offsetHeight)/2 + header.offsetHeight/2 + 'px'
        // stickyEl.style.top = window.innerHeight/2 - document.querySelector('header').offsetHeight + 'px'
        //sync bulletnav
        bulletNav.style.top = window.innerHeight/2 - bulletNav.offsetHeight/2 + header.offsetHeight/2 + 'px'
        // document.querySelector('#be-anim-bulletnav').style.top = stickyEl.style.top
    } else { 
        stickyEl.style.top = document.querySelector('header').offsetHeight + 'px'
        document.querySelector('#be-anim-bulletnav').style.top = window.innerHeight/2 + 'px'
    }
    
}

//dynamic scrolltrigger hook
function scrollTriggerHookPos(){
    const aspectRatio = window.innerWidth / window.innerHeight
    if(aspectRatio < 1 && window.innerWidth < 1024){ //low dpi
        return .7
    } else {
        return .5
    }
}

function scrollToBullet(){
    const index = this.getAttribute('data-id')
    var destBullet = document.querySelector(`.be-clever-bullet[data-scene-index="${index-1}"]`)

    var midScreenOffset =  destBullet.offsetHeight/2
    if(scrollTriggerHookPos() > .5){ //mobile
        midScreenOffset = document.querySelector(`#be-clever-anim-img-cont`).offsetHeight
    }

    const getOffsetTop = element => {
        let offsetTop = 0;
        while(element) {
          offsetTop += element.offsetTop;
          element = element.offsetParent;
        }
        return offsetTop;
      }

    window.scrollTo({
        top: getOffsetTop(destBullet) - midScreenOffset - document.querySelector('header').offsetHeight/2,
        behavior: 'smooth'
    });
}

//build and remove click events on svg bullet points
function setInteractiveBulletEvents(){
    document.querySelectorAll('.be-clever-anim-svg-bullet, .be-anim-nav-bullet').forEach((item,index)=>{
        item.removeEventListener('click',scrollToBullet)
    })

    document.querySelectorAll('.be-clever-anim-svg-bullet, .be-anim-nav-bullet').forEach((item,index)=>{
        item.addEventListener('click',scrollToBullet)
    })
}


var initLayout = async function(){

    if(document.querySelector('#be-clever-anim') != null){
        setInteractiveBulletEvents()
        return
    }

    setInteractiveBulletEvents()

    var img = new Image();
    img.onload = () => {setStickyPos()}
    img.src = "https://www.bushcraft-essentials.com/media/image/0d/67/dd/BE-Clever-interactive-gfx_img.png";
}

var scrollMagicScenes = []
function initScrollMagic(){
    var controller = new ScrollMagic.Controller();
    var scenes = document.querySelectorAll('.be-clever-bullet')

    var activeScene = 0
    for(var i = 0; i < scenes.length; i++){

        scenes[i].setAttribute('data-scene-index',i)
        
        var scene = new ScrollMagic.Scene({
            triggerElement: scenes[i],
            triggerHook: scrollTriggerHookPos(),
            offset: 40, /* offset the trigger 150px below #scene's top */
        })
        .addTo(controller);
        
        scene.on('enter',(e)=>{
            const formerIndex = activeScene
            var sceneIndex = parseInt(e.target.triggerElement().getAttribute('data-scene-index'))
            activeScene = sceneIndex
            setActiveSVGBullet(formerIndex,activeScene,e.scrollDirection)
        })
        
        scene.on('leave',(e)=>{
            if(activeScene == 0) return
            var formerIndex = activeScene
            activeScene = e.scrollDirection == 'REVERSE' ? formerIndex - 1 : activeScene

            setActiveSVGBullet(formerIndex,activeScene,e.scrollDirection)
        })
        
        scrollMagicScenes.push(scene)
        // scene.addIndicators();
    }

    function setActiveSVGBullet(formerIndex,newIndex,scrollDirection){

        var newActive = document.querySelectorAll(`
            [data-id="${newIndex+1}"],
            g[data-id="${newIndex+1} line"],
            .be-anim-nav-bullet[data-id="${newIndex+1}"],
            .be-anim-nav-bullet[data-id="${newIndex+1}"],
            [data-scene-index="${newIndex}"],
            .be-data-bullet-${newIndex+1}
        `)
        newActive.forEach((item, index)=>{
            if(item != null){
                item.classList.add('active')
                item.tagName =! 'g' && item.classList.contains('isDown') ? item.classList.remove('isDown') : null
                item.tagName =! 'g' && item.classList.contains('isUp') ? item.classList.remove('isUp') : null
            }
        })

        if(formerIndex == newIndex) return //avoid removal of active class on init
        var formerActive = document.querySelectorAll(`
            [data-id="${formerIndex+1}"],
            g[data-id="${formerIndex+1} line"],
            .be-anim-nav-bullet[data-id="${formerIndex+1}"],
            .be-anim-nav-bullet[data-id="${formerIndex+1}"],
            [data-scene-index="${formerIndex}"],
            .be-data-bullet-${formerIndex+1}
        `)

        formerActive.forEach((item, index)=>{
            if(item != null && item.classList.contains('be-clever-animation-img')){
                if(!item.classList.contains(`be-data-bullet-${newIndex+1}`)){
                    item.classList.remove('active')
                }
            } else {
                if(item != null && item.classList.contains('active')){
                    item.classList.remove('active')
                }
            }

            if(item != null && scrollDirection == 'FORWARD'){
                item.classList.contains('isDown') ? item.classList.remove('isDown') : null
                item.classList.add('isUp')
            } else if(item != null && scrollDirection == 'REVERSE') {
                item.classList.contains('isUp') ? item.classList.remove('isUp') : null
                item.classList.add('isDown')
            }
        })

    }
}

function updateScrollMagic(){
    for(var i = 0; i < scrollMagicScenes.length; i++){
        scrollMagicScenes[i].removePin(true);
        scrollMagicScenes[i].setPin(scrollMagicScenes[i]);
        scrollMagicScenes[i].triggerHook(scrollTriggerHookPos())
        scrollMagicScenes[i].refresh();
    }
}